import React from "react"
import Layout from "../components/layout"
import { Link, graphql } from "gatsby"
import Seo from "../components/seo"
import {
  // LazyLoadImage,
  LazyLoadComponent,
} from "react-lazy-load-image-component"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import { FaLinkedin } from "react-icons/fa"
import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"
import "./about.css"
import Banner from "../components/hero/banner-aboutus.js"
import { FaPlus } from "react-icons/fa"

const Modal = loadable(() =>
  pMinDelay(import("../components/modal/team-modal"), 500)
)

class AboutPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      teambio: null,
    }
  }

  render() {
    console.log("team modal test", this.state.teambio)

    const { data } = this.props
    const teams = data.allSanityTeam.edges
    return (
      <Layout banner={<Banner />} location={this.props.location}>
        <Seo
          title="About Us | Quandary Consulting Group"
          description="We're a Denver-based IT Consulting firm that builds low-code solutions for mid-market and enterprise organizations. Learn about our process and vision."
        />
        <div
          // id="consulting"
          style={{ paddingTop: "25px", marginTop: "-20px" }}
        />
        <section style={{ padding: "3rem 0" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center text-left-mobile">
                <h2 className="mb-4">Quandary Consulting Group at a Glance</h2>
                <p>
                  We're a technology management consulting firm based in Denver,
                  Colorado with a simple mission: create better ways for
                  companies to do business. Building an agile business that can
                  rapidly adapt to changing demands isn't impossible.
                </p>
                <p>
                  By automating processes, you can increase productivity, cut
                  costs, and reduce waste. Drastically. You'll also get clean,
                  actionable data in easily understood dashboards. Best of all,
                  your investment in better software solutions will pay for
                  itself in labor reduction, error reduction, and overall cost
                  reduction.
                </p>
                <p>
                  As your technology consultants, we help you automate away the
                  stress of trying to scale a growing business. Leveraging
                  powerful low-code platforms like Quickbase, Pipefy, and
                  Workato, we build the custom integrations and applications you
                  need at a fraction of the cost (and much faster) than
                  traditional software development.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section style={{ padding: "3rem 0", background: "#f8f8f8" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="about-titlehead">
                  Peak or Problem? We Help You Conquer Both.
                </h2>
              </div>
              <div className="col-lg-6 mt-5">
                <StaticImage
                  placeholder="blurred"
                  className="rounded w-100"
                  src="../images/new-images/quandary-peak.jpg"
                  alt="Quandary Peak, Colorado 14,265 feet"
                  style={{ height: "25rem" }}
                  loading="lazy"
                />

                <p
                  className="text-black mt-3 text-center"
                  style={{ fontSize: "16px" }}
                >
                  Quandary Peak, Colorado 14,265 feet
                </p>
              </div>
              <div className="col-lg-6 mt-5">
                <StaticImage
                  className="rounded w-100"
                  placeholder="blurred"
                  src="../images/new-images/quandary-state.jpg"
                  alt="Quandary: state of perplexity or uncertainty over what to do in a difficult situation"
                  style={{ height: "25rem", position: "relative" }}
                  loading="lazy"
                />

                <p
                  className="mt-3 text-center text-black text-center"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Quandary: state of perplexity or uncertainty over what to do
                  in a difficult situation
                </p>
              </div>
            </div>
          </div>
        </section>
        <section
          id="why-choose-us"
          className="why-choose-us"
          style={{ padding: "3rem 0" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center mb-lg-5 mb-3">
                <h2 className="font-weight-medium text-left-mobile about-titlehead">
                  Why Work with Quandary Consulting Group?
                </h2>
              </div>
            </div>
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-6">
                <p className="h4 d-none d-lg-block d-md-block">From This...</p>
                <p>
                  Every business wants growth. Few are ready for it. The
                  processes and systems businesses typically start with don’t
                  scale. This forces organizations to work around their systems,
                  making work slow, inefficient, and expensive.
                </p>
                <p>
                  Over time, employees and executives exhaust themselves trying
                  to fill the gaps. And we all know that outcome. Longer hours.
                  Overworking. Burnout. Your team, trapped by manual processes,
                  slips away from strategic tasks. Meanwhile, your frustrated
                  customers (and staff) start looking for other options…
                </p>
                {/* <p>And we all know that outcome.</p>
                <p>
                  Longer hours. Overworking. Burnout. Your team, trapped by
                  manual processes, slips away from strategic tasks.
                </p>
                <p>
                  Meanwhile, your frustrated customers (and staff) start looking
                  for other options…
                </p> */}
              </div>
              <div className="col-lg-6 mt-lg-0 mt-md-0 mt-3 align-self-center pb-lg-0 pb-5">
                <p className="h4 mb-4 d-block d-lg-none d-md-none">
                  From This...
                </p>
                <StaticImage
                  className="rounded w-100 img-fluid"
                  placeholder="blurred"
                  src="../images/new-images/why-choose-quandary.jpg"
                  alt="Why Choose Quandary"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 mt-lg-5 mt-md-5 mt-5">
                <p className="h4 mb-4 d-block d-lg-none d-md-none">
                  To This...
                </p>
                <StaticImage
                  className="rounded w-100 img-fluid"
                  placeholder="blurred"
                  src="../images/new-images/mumbo-jumbo.jpg"
                  alt="Mumbo Jumbo"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-6 margin-text-lg margin-text-mobile results">
                <p className="h4 d-none d-lg-block d-md-block">To This... </p>
                <p>
                  Quandary Consulting Group helps businesses scale by building
                  better systems that reduce manual tasks. We leverage our
                  extensive background in low code and rapid application
                  development platforms to build lean systems that automate and
                  integrate away the pain of growing your business. And we do it
                  faster, cheaper, and better than trying to do it in-house.
                </p>
                {/* <p>
                  We leverage our extensive background in low code and rapid
                  application development platforms to build lean systems that
                  automate and integrate away the pain of growing your business.
                  And we do it faster, cheaper, and better than trying to do it
                  in-house.
                </p> */}
                <p>
                  <strong>The results are clear:</strong>
                </p>
                <ul>
                  <li>
                    Better systems eliminate waste, freeing up more time and
                    resources.
                  </li>
                  <li>Employees can focus on high-level, strategic work.</li>
                  <li>
                    Customers experience higher levels of support and care.
                  </li>
                  <li>
                    Businesses rapidly grow without tripping over their systems.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section
          className="bg-indigo business-with-us"
          style={{
            padding: "3rem 0",
          }}
        >
          <div className="container">
            <div className="col-lg-row">
              <div className="col-lg-12">
                <h2 className="text-white text-center mb-4 text-left-mobile">
                  Benefits of Quandary Consulting Group
                </h2>
                <div className="col-md-10 mx-auto about-us-xp">
                  <div className="d-flex align-item-center justify-content-center mb-2">
                    <div className="col-sm-5">
                      <ul>
                        <li className="mb-2">Faster Application Development</li>
                        <li className="mb-2">Clean, Actionable Data</li>
                        <li>Improved Business Agility</li>
                      </ul>
                    </div>
                    <div className="col-sm-5">
                      <ul>
                        <li className="mb-2">Ongoing Consultative Insights</li>
                        <li className="mb-2">
                          Cost-Reduction and Time-Savings
                        </li>
                        <li>Change-Management Support</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          style={{
            padding: "3rem 0",
            background: "#ecf0f2",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center text-left-mobile">
                <h2 className="about-titlehead">Why All the Mountain Speak?</h2>
                <p>No. We’re not a hiking company…</p>
                <p>
                  However, as a Denver-based technology consultancy, we know
                  mountains and the struggles organizations face when trying to
                  scale success. And we know how to get our clients to the top.
                  That's why PEAKS serves as a foundation for all our services.
                </p>
                {/* <p>
                  That's why PEAKS serves as a foundation for all our services.
                </p> */}
              </div>

              <div className="col-lg-8 mx-auto text-center mt-5">
                <Link
                  aria-label="link"
                  className="btn btn-primary btn-arrow"
                  to="/our-approach/"
                >
                  LEARN ABOUT PEAKS
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section
          id="team"
          style={{
            padding: "3rem 0",
            background: "#fff",
          }}
        >
          <div className="container">
            <div className="intro text-center mb-5">
              <p className="h5 text-light-blue text-uppercase font-weight-bold mb-lg-1 mb-1 about-titlehead">
                LEADERSHIP TEAM
              </p>
            </div>
            <div className="row px-5">
              {teams.map(({ node }) => (
                <div className="col-md-4 col-lg-3 px-4 px-lg-4 px-md-3">
                  <div className="quandary-team-member mb-4">
                    <div className="quandary-team-member-inner">
                      <div className="quandary-team-image">
                        {node?.image?.asset?.gatsbyImageData ? (
                          <GatsbyImage
                            image={node?.image?.asset?.gatsbyImageData}
                            imgClassName="img-fluid"
                            alt={node?.name}
                            // width={600}
                            placeholder="blurred"
                            style={{ height: "16rem", width: "100%" }}
                          />
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              height: "256px",
                              width: "270px",
                              backgroundColor: "#f7f2f2",
                            }}
                          >
                            {" "}
                            <svg width="208" height="208" viewBox="0 0 480 480">
                              <path
                                fill="currentColor"
                                d="M240 0C107.664 0 0 107.664 0 240c0 57.96 20.656 111.184 54.992 152.704.088.12.096.272.192.384 24.792 29.896 55.928 52.816 90.624 67.624.4.168.792.352 1.192.52 2.808 1.184 5.648 2.28 8.496 3.352 1.12.424 2.24.856 3.376 1.264 2.456.88 4.928 1.712 7.416 2.512 1.592.512 3.184 1.016 4.792 1.496 2.2.656 4.408 1.288 6.632 1.888 1.952.528 3.92 1.016 5.888 1.488 1.992.48 3.992.96 6 1.384 2.24.48 4.504.904 6.776 1.32 1.824.336 3.64.688 5.48.984 2.52.408 5.056.728 7.6 1.056 1.64.208 3.272.448 4.92.624 2.88.304 5.784.52 8.696.72 1.352.096 2.696.24 4.056.312 4.248.24 8.544.368 12.872.368s8.624-.128 12.888-.352c1.36-.072 2.704-.216 4.056-.312 2.912-.208 5.816-.416 8.696-.72 1.648-.176 3.28-.416 4.92-.624 2.544-.328 5.08-.648 7.6-1.056 1.832-.296 3.656-.648 5.48-.984 2.264-.416 4.528-.84 6.776-1.32 2.008-.432 4-.904 6-1.384 1.968-.48 3.936-.968 5.888-1.488a232.661 232.661 0 0011.424-3.384c2.488-.8 4.96-1.632 7.416-2.512 1.128-.408 2.248-.84 3.376-1.264a243.168 243.168 0 008.496-3.352c.4-.168.792-.352 1.192-.52a239.997 239.997 0 0090.624-67.624c.096-.112.104-.272.192-.384C459.344 351.184 480 297.96 480 240 480 107.664 372.336 0 240 0zm97.256 441.76c-.12.056-.232.12-.352.176-2.856 1.376-5.76 2.672-8.688 3.936-.664.28-1.32.568-1.984.848a217.023 217.023 0 01-7.76 3.064 159.85 159.85 0 01-3.272 1.192 230.572 230.572 0 01-6.976 2.368c-1.456.464-2.92.904-4.384 1.336a202.08 202.08 0 01-6.28 1.784c-1.776.472-3.568.904-5.36 1.328-1.88.448-3.752.904-5.648 1.304-2.072.44-4.16.816-6.24 1.192-1.688.312-3.368.64-5.072.912-2.344.368-4.712.664-7.072.96-1.496.192-2.984.416-4.496.576-2.696.288-5.416.472-8.128.664-1.208.08-2.408.216-3.632.28-3.96.208-7.928.32-11.912.32s-7.952-.112-11.904-.32c-1.216-.064-2.416-.192-3.632-.28-2.72-.184-5.432-.376-8.128-.664-1.512-.16-3-.384-4.496-.576-2.36-.296-4.728-.592-7.072-.96-1.704-.272-3.384-.6-5.072-.912-2.088-.376-4.176-.76-6.24-1.192-1.896-.4-3.776-.856-5.648-1.304-1.792-.432-3.584-.856-5.36-1.328-2.104-.56-4.2-1.168-6.28-1.784a212.543 212.543 0 01-4.384-1.336 223.256 223.256 0 01-6.976-2.368 217.023 217.023 0 01-11.032-4.256c-.664-.272-1.312-.56-1.976-.84a223.812 223.812 0 01-8.696-3.936 7.216 7.216 0 01-.352-.176c-27.912-13.504-52.568-32.672-72.576-55.952 15.464-56.944 59.24-102.848 115.56-121.112 1.112.68 2.272 1.288 3.416 1.928.672.376 1.336.776 2.016 1.136a99.592 99.592 0 007.272 3.512c1.896.832 3.856 1.536 5.808 2.256.384.136.768.288 1.152.424 10.848 3.84 22.456 6.04 34.6 6.04s23.752-2.2 34.592-6.04c.384-.136.768-.288 1.152-.424 1.952-.72 3.912-1.424 5.808-2.256a99.592 99.592 0 007.272-3.512c.68-.368 1.344-.76 2.016-1.136 1.144-.64 2.312-1.248 3.432-1.936 56.32 18.272 100.088 64.176 115.56 121.112-20.008 23.272-44.664 42.44-72.576 55.952zM152 176c0-48.52 39.48-88 88-88s88 39.48 88 88c0 30.864-16.008 58.024-40.128 73.736a84.742 84.742 0 01-9.8 5.48c-.4.192-.792.392-1.192.576-23.168 10.536-50.592 10.536-73.76 0-.4-.184-.8-.384-1.192-.576a84.083 84.083 0 01-9.8-5.48C168.008 234.024 152 206.864 152 176zm269.832 194.584c-18.136-53.552-59.512-96.832-112.376-117.392C330.6 234.144 344 206.64 344 176c0-57.344-46.656-104-104-104s-104 46.656-104 104c0 30.64 13.4 58.144 34.552 77.192-52.864 20.568-94.24 63.84-112.376 117.392C31.672 333.792 16 288.704 16 240 16 116.488 116.488 16 240 16s224 100.488 224 224c0 48.704-15.672 93.792-42.168 130.584z"
                              ></path>
                            </svg>
                          </div>
                        )}
                        <div className="row pt-3 pl-2">
                          <div>
                            {" "}
                            <Modal teambio={node} />
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p
                              className="h4 mb-0 mr-2"
                              style={{ color: "#00b5f4" }}
                            >
                              {node.name}
                            </p>
                            {node.linkedin ? (
                              <a
                                href={node.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-center mb-0"
                                style={{
                                  position: "relative",
                                  zIndex: "1",
                                }}
                              >
                                <span
                                  style={{
                                    background: "#fff",
                                    // padding: "0.1rem 0.5rem",
                                    borderRadius: "0.2rem",
                                  }}
                                >
                                  <FaLinkedin
                                    color="#0D65A6"
                                    style={{ height: "2em", width: "1.2em" }}
                                  />
                                </span>
                              </a>
                            ) : (
                              <a
                                href={node.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-center mb-2"
                              >
                                <p className="h4 mb-0">{node.name}</p>
                              </a>
                            )}
                          </div>
                        </div>
                        <small className="mb-0">{node.position}</small>

                        {/* <p className="mb-0">
                          {node.bio && node.bio.children
                            ? node.bio.children.map((child, index) => (
                                <span key={index}>{child.text} </span>
                              ))
                            : null}
                        </p> */}
                      </div>

                      <div className="quandary-team-social" />

                      {/* <a
        //   aria-label="button"
          className="h6 mb-0 mr-2 pe-auto"
          onClick={this.handleShow}
        >
        View Bio
        </a> */}

                      {/* <button onClick={() => this.setState({ teambio: node })}>
                        View Bio
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default AboutPage

export const TeamQuery = graphql`
  query TeamQuery {
    allSanityTeam(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          state
          address
          name
          linkedin
          position
          image {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          bio
        }
      }
    }
  }
`
